import { render } from "./CampaignsOverview.vue?vue&type=template&id=8f37d94e"
import script from "./CampaignsOverview.vue?vue&type=script&lang=js"
export * from "./CampaignsOverview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__